/* eslint-disable @typescript-eslint/await-thenable */
import * as React from 'react';
import { FlatViewOrderSinglePageDesktop, ICallbackParams } from '@cian/newbuilding-flat-view-order-component';
import { Button } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-restricted-paths
import { addFlatTourBooking } from '../../../browser/services/flatTourBooking';
import { getIsFlatTourBookingAvailable, getFlatTourBookingSchedule } from '../../selectors/flatTourBooking';
import { getDisplayName, getNewbuildingId, getIsFlatViewOrderEnabled } from '../../selectors/newbuilding';
import { TThunkDispatch } from '../../types/redux/thunk';
import { trackFlatViewOrderPopupOpen, trackFlatViewOrderSuccess } from '../FlatViewOrderPopup/tracking';

export function FlatViewOrderHeaderPopupContainer() {
  const [isPopupOpened, setPopupVisibility] = React.useState(false);
  const dispatch: TThunkDispatch = useDispatch();
  const isFlatTourBookingAvailable = useSelector(getIsFlatTourBookingAvailable);
  const isEnabled = useSelector(getIsFlatViewOrderEnabled);
  const newbuildingName = useSelector(getDisplayName);
  const newbuildingId = useSelector(getNewbuildingId);
  const schedule = useSelector(getFlatTourBookingSchedule);

  const onButtonClick = React.useCallback(() => {
    trackFlatViewOrderPopupOpen('personal_tour_blockStickytop');

    setPopupVisibility(true);
  }, [setPopupVisibility]);

  const handlePopupClose = React.useCallback(() => {
    setPopupVisibility(false);
  }, []);

  const onSuccess = React.useCallback((params: ICallbackParams) => {
    trackFlatViewOrderSuccess(params);
  }, []);

  const onSubmit = React.useCallback(
    async (params: ICallbackParams) => {
      try {
        const parameters = {
          phone: params.phone,
          tourTime: `${params.date} ${params.time}`,
          fullName: params.name,
          newbuildingId,
        };

        await dispatch(addFlatTourBooking(parameters));

        return true;
      } catch {
        return false;
      }
    },
    [dispatch],
  );

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Button theme="fill_secondary" size="XS" onClick={onButtonClick} disabled={!isFlatTourBookingAvailable}>
        Записаться на просмотр
      </Button>
      {schedule && (
        <FlatViewOrderSinglePageDesktop
          isOpen={isPopupOpened}
          onClose={handlePopupClose}
          onSuccess={onSuccess}
          onSubmit={onSubmit}
          disabledDays={schedule.disabledDays}
          availableDates={schedule.availableDates}
          newbuildingName={newbuildingName}
          minDate={schedule.minDate}
          maxDate={schedule.maxDate}
          nextDate={schedule.nextDate}
          nextNextDate={schedule.nextNextDate}
        />
      )}
    </>
  );
}
